import { CommonUtil } from "@/utils/common.util";
import { SaleProcessFiltersDto } from "../models/saleProcess.model";

export function mapSaleProcessFiltersDtoToQuery({ filters }: { filters: SaleProcessFiltersDto }): Record<string, string> {
	const { limit, page, id, phone, mobilePhone, dateFrom, dateTo, user, status, channel, customerType, customerId, identificationNumber } = filters;
	const query = {
		limit,
		page,
		id,
		phone,
		mobilePhone,
		dateFrom,
		dateTo,
		updatedBy: user,
		status,
		channel,
		customerType,
		customerId,
		identificationNumber
	};

	return CommonUtil.clearObjectEmptyStrings({ obj: query });
}
